import React from 'react';

import { ApolloError } from '@apollo/client';
import { Text } from '@betterment/samba-react';

import { DisplayableError } from '../../../graphql/schema';

export interface ReviewOrderErrorProps {
  submitOrderDisplayableErrors?: DisplayableError[];
  submitOrderMutationError?: ApolloError;
  previewDisplayableErrors?: DisplayableError[];
  previewMutationError?: ApolloError;
}

const GENERIC_SUBMIT_ERROR_MESSAGE =
  "We couldn't complete your request. Please refresh the page or try again later. If the issue persists, contact our support team.";

export const ReviewOrderError: React.FC<ReviewOrderErrorProps> = ({
  submitOrderDisplayableErrors,
  submitOrderMutationError,
  previewMutationError,
}) => {
  const hasSubmitOrderErrors =
    (submitOrderDisplayableErrors && submitOrderDisplayableErrors.length > 0) || submitOrderMutationError;
  const hasPreviewErrors = previewMutationError;

  if (!hasSubmitOrderErrors && !hasPreviewErrors) {
    return null;
  }

  return <Text css={{ textStyle: 'text50', color: 'text.critical' }}>{GENERIC_SUBMIT_ERROR_MESSAGE}</Text>;
};
